import React, { useEffect } from 'react'
import apiClient from '../../gears/apiClient';
import PageLoader from '../../components/PageLoader';

const ClassLinkSsoLaunch = () => {
  useEffect(() => {
    const fetchRedirectUrl = async () => {
      try {
        const redirectUrl = await apiClient.get('/auth/classlink/redirect-link');
        window.location.replace(redirectUrl);
      } catch (e) {
        window.location.replace(`/admin/login?error=${e.message}`);
      }
    };
    fetchRedirectUrl();
  }, []);

  return <PageLoader />;
}

export default ClassLinkSsoLaunch;
